let isRequestPending = false
const resolves: ((value: unknown) => void)[] = []

export const waitFunctionResolve = async (fn: () => Promise<any>) => {
    if (isRequestPending) {
        return new Promise((resolve) => {
            resolves.push(resolve)
        })
    }

    isRequestPending = true

    return new Promise((resolve) => {
        fn().then((result) => {
            resolve(result)

            isRequestPending = false

            if (resolves.length > 0) {
                resolves.forEach((resolve) => {
                    resolve(result)

                    resolves.shift()
                })
            }
        })
    })
}
